<ng-template #errorTemplate>
  <udex-message-strip *ngIf="entries?.length" design="Negative" status-type="Icon" hide-close-button>
    <div *ngIf="entries?.length === 1">
      <p>
        {{'checkout.error.singleProductNotLoaded' | cxTranslate}}
        <strong>{{productUtilitiesService.getNameAndSupplierAlternativeAid(entries[0].product)}}.</strong>
        {{'checkout.error.please' | cxTranslate}}
        <udex-link (click)="reloadCart()" (keydown.enter)="reloadCart()" data-cy="reload-cart-button">
          {{'checkout.error.refreshPage' | cxTranslate}}</udex-link>
        {{'checkout.error.singleProductTryAgain' | cxTranslate}}
        <udex-link (click)="contactSupport()" (keydown.enter)="contactSupport()" data-cy="contact-support-link-single">
          {{'checkout.error.contactSupport' | cxTranslate}}</udex-link>
        {{'checkout.error.singleProductRemoveFromCart' | cxTranslate}}
      </p>
    </div>
    <div *ngIf="entries?.length > 1">
      <p>
        {{'checkout.error.multipleProductsNotLoaded' | cxTranslate}}
        {{'checkout.error.please' | cxTranslate}}
        <udex-link (click)="reloadCart()" (keydown.enter)="reloadCart()" data-cy="reload-cart-button">
          {{'checkout.error.refreshPage' | cxTranslate}}
        </udex-link>
        {{'checkout.error.multipleProductsTryAgain' | cxTranslate}}
        <udex-link (click)="contactSupport()" (keydown.enter)="contactSupport()" data-cy="contact-support-link-multi">
          {{'checkout.error.contactSupport' | cxTranslate}}</udex-link>
        {{'checkout.error.multipleProductsRemoveFromCart' | cxTranslate}}
      </p>
      <ul class="udex-m-0 body--s">
        <li *ngFor="let e of entries" class="">
          {{productUtilitiesService.getNameAndSupplierAlternativeAid(e.product)}}
        </li>
      </ul>
    </div>
  </udex-message-strip>
</ng-template>
